"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b ||= {})
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
import React from "react";
import classNames from "classnames";
import { IconSize } from "../types";
import * as styles from "../Icons-css";
const Qwilr = (props) => {
  const _a = props, { className, size = IconSize.Medium, color = "inherit" } = _a, rest = __objRest(_a, ["className", "size", "color"]);
  const iconClass = classNames(
    styles.icon({
      size,
      color
    }),
    "kl-icon",
    `kl-icon--${size}`,
    className
  );
  return React.createElement(
    "svg",
    __spreadValues({ width: "24", height: "24", viewBox: "0 0 24 24", className: iconClass }, rest),
    /* @__PURE__ */ React.createElement("path", { fill: "#fff", d: "M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12Z" }),
    /* @__PURE__ */ React.createElement(
      "path",
      {
        fill: "#00A99D",
        d: "m6.49 15.003 1.39 2.118a.611.611 0 0 0 1.013 0l3.105-4.92L9.69 8.535l-3.22 5.243a1.136 1.136 0 0 0 .02 1.225Z"
      }
    ),
    /* @__PURE__ */ React.createElement(
      "path",
      {
        fill: "#EF445A",
        d: "m17.53 13.778-3.22-5.244-2.312 3.674 3.109 4.92a.592.592 0 0 0 .506.272.611.611 0 0 0 .507-.273l1.39-2.118a1.148 1.148 0 0 0 .02-1.23Z"
      }
    ),
    /* @__PURE__ */ React.createElement(
      "path",
      {
        fill: "#01445A",
        d: "m13.427 7.093-.919-1.418a.61.61 0 0 0-1.016 0l-.919 1.42-.884 1.44 2.31 3.673L14.31 8.55l-.884-1.457Z"
      }
    ),
    /* @__PURE__ */ React.createElement("circle", { cx: 12, cy: 12, r: 11.5, stroke: "#D1D7E2", fill: "none" })
  );
};
export default Qwilr;
